<div class="error-page">
  <div class="error-card">
    <div class="error-icon">
      <svg-icon src="assets/icons/shield.svg" [svgStyle]="{ 'width.px': 26, 'height.px': 26 }" aria-hidden="true"></svg-icon>
    </div>
    <div class="error-num">403</div>
    <div class="error-num-text">No access</div>
    <h1 class="error-title">You don't have access to this page</h1>
    <p class="error-desc">Your account does not have the permission this page needs. If you think you should have access, ask your administrator.</p>
    <div class="error-actions">
      <button nz-button nzType="primary" nzShape="round" (click)="goBack()">
        <svg-icon src="assets/icons/arrow-left.svg" class="btn-icon btn-icon--light" aria-hidden="true"></svg-icon>
        Go back
      </button>
      <button nz-button nzType="default" nzShape="round" (click)="goHome()">
        <svg-icon src="assets/icons/home.svg" class="btn-icon" aria-hidden="true"></svg-icon>
        Home
      </button>
    </div>
  </div>
</div>
